export default __webpack_public_path__ + "static/media/969.2c9a48d8.gif";